import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

const { mayoEggWhite } = colors

const Stroke = (props: Icon) => {
    const { width = 17, height = 15, color = mayoEggWhite } = props
    return (
        <svg width={width} height={height} viewBox="0 0 17 15" fill="none">
            <path
                d="M1 14L16 1"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    )
}

export { Stroke }
